<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑模型
            </div>
        </div>
        <div class="dialog_body" style="padding: 25px">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px">
                <el-form-item label="模型名称" prop="modelname">
                    <el-input v-model="form.modelname" placeholder="请输入模型名称"></el-input>
                </el-form-item>
                <el-form-item label="模型分类">
                    <el-select v-model="form.category" placeholder="请选择模型分类" style="width:100%">
                        <el-option v-for="item in flowFlag" :label="item.dictionaryName" :value="item.dictionaryCode" :key="item.dictionaryId"></el-option>
<!--                        <el-option label="公司岗位" value="00101"></el-option>-->
                    </el-select>
                </el-form-item>
                <el-form-item label="模型描述">
                    <el-input v-model="form.description" placeholder="请输入模型描述"></el-input>
                </el-form-item>
                <el-form-item label="流程名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入流程名称"></el-input>
                </el-form-item>
                <el-form-item label="流程标识">
                    <el-select v-model="form.process_id" filterable placeholder="请选择流程标识" style="width:100%">
                        <el-option v-for="item in flowType" :label="item.dictionaryName" :value="item.dictionaryCode" :key="item.dictionaryId"></el-option>
<!--                        <el-option label="离职流程" value="KEY_leave"></el-option>-->
<!--                        <el-option label="物资入库审核" value="KEY_IntoBill"></el-option>-->
                    </el-select>
                </el-form-item>
                <el-form-item label="流程作者">
                    <el-input v-model="form.process_author" placeholder="请输入流程作者"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>


        </div>
    </el-dialog>

</template>

<script>
    import store from "../../../store";

    export default {
        name: "editDialog",
        props: ['formData', 'loading','source_id'],
        data() {
            return {
                dialoading: this.loading,
                form: {},
                dialogVisible: true,
                formLabelWidth: '80px',
                flowType:[],
                flowFlag:[],
            };
        },
        async mounted() {
            await this.getFlowType();
            await this.getFlowFlag();

            this.form = {
                process_author:"admin",
            }
        },
        methods: {
            async getFlowType(){
                let param = {
                    url:"/dictionaries/list",
                    param:{
                        parentId:"act002",
                        pageSize:"100",
                        currentPage:"1",
                    }
                }
                const data = await store.dispatch('pubMethod', param);
                this.flowType = data.data.varList;
            },
            async getFlowFlag(){
                let param = {
                    url:"/dictionaries/list",
                    param:{
                        parentId:"act001",
                        pageSize:"100",
                        currentPage:"1",
                    }
                }
                const data = await store.dispatch('pubMethod', param);
                this.flowFlag = data.data.varList;
            },


            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if (this.form.modelname == null) {
                    this.$message({message: '请输入模型名称', type: 'error'});
                    return false;
                }
                if (this.form.category == null) {
                    this.$message({message: '请选择模型分类', type: 'error'});
                    return false;
                }
                if (this.form.name == null) {
                    this.$message({message: '请输入流程名称', type: 'error'});
                    return false;
                }
                if (this.form.process_id == null) {
                    this.$message({message: '请选择流程标识', type: 'error'});
                    return false;
                }
                this.form.source_id = this.source_id;
                this.$emit('copySubmitForm', this.form)
            },
        }
    }
</script>

<style scoped>
    .el-select-dropdown__list li:last-child{  padding-bottom: 45px;}

</style>
